import ApiService from "../../utils/fetch";
const userRolesUrl = `${process.env.REACT_APP_BACKEND_BASE_URL}/user-access/`;

export const fetchAllReports = async (source = '', userEmail = '', applicationType) => {
    const url = `${userRolesUrl}getAllReportsForSSAANDCC`;

    const params =
        source === "USER_SPECIFIC"
            ? { applicationType, userEmail }
            : { applicationType };

    const response = await ApiService.get(
        url,
        params,
        { meta: { suppressToast: true } }
    );
    return response.data;
}

// export const fetchAllReports = async (applicationType) => {
//     const url = `${userRolesUrl}getAllReportsForSSA?applicationType=${applicationType}`;
//     const response = await ApiService.get(url);
//     return response.data;
// }

export const revokeUserAccess = async (payload) => {
    const url = `${userRolesUrl}revokeUserAccess`;
    const response = await ApiService.delete(url, payload);
    return response.data;
};

export const handleUserAccess = async (status, payload) => {
    const url = `${userRolesUrl}enableDisableUserAccess?isActive=${status}`;
    const response = await ApiService.put(url, payload, { meta: { suppressToast: true } });
    return response.data;
}